require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2003-09-08-why-debian-sucks.json") })
        }
      }, "path---articles-2003-09-08-why-debian-sucks");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2003-09-08-why-debian-sucks!./.cache/json/articles-2003-09-08-why-debian-sucks.json
// module id = 331
// module chunks = 231608221292675